$(document).ready(function () {
  // Make body the active element on page load
  document.body.focus();
  document.activeElement.blur();
    
  //Handle aspect ratio on page load
  setTimeout(setAspectRatio, 2000);
  //Handle aspect ratio on click on filters and clear All functionality
  setTimeout(setFilters, 2000);
  setTimeout(logAllURLParameters,2000);
  setTimeout(setSearchParameter,2000);
  setTimeout(setPriceRangeSlider,2000);
  setTimeout(setSortChange,2000)
  //Handle aspectio ratio of image on pagination
  $(document).on("click", ".blm-category-pagination__page-link", handlePaginationClick);
  $(document).on("click", ".blm-product-search-pagination__page-link", handlePaginationClick);

  function handlePaginationClick(event) {
    setTimeout(setAspectRatio, 2000);
    setTimeout(logAllURLParameters,1000);
  }

  //Handle aspect ratio on page scroll
    function isMobileView() {
      return window.innerWidth <= 680; // Adjust the breakpoint as needed
    }
  
    function handleScroll() {
    if (isMobileView()) {
     setTimeout(setAspectRatio, 2000);
      setTimeout(logAllURLParameters,1000);
    }
  }
  document.addEventListener("scroll", handleScroll);

  // Function to handle the click event for filter titles
  function handleFilterClick(titleClass, itemsClass) {
    $(document).on("click", titleClass, function () {
      var items = $(this).next();
      if (
        items.hasClass(itemsClass) ||
        items.hasClass("blm-price-range-container")
      ) {
        var isOpen = $(this).hasClass("collapsed");
        if (isOpen) {
          $(this).removeClass("collapsed");
          items.stop().slideDown();
        } else {
          $(this).addClass("collapsed");
          items.stop().slideUp(); // Corrected from 'item' to 'items'
        }
      }
    });
  }

  // Handling the first case
  handleFilterClick(".blm-category-filter-title", "blm-category-filter-items");

  // Handling the second case
  handleFilterClick(
    ".blm-product-search-filter-title",
    "blm-product-search-filter-items"
  );
    // Function to collapse all filter items
    function collapseAllFilterItems() {
      $(".blm-category-filter-title, .blm-product-search-filter-title").each(function () {
        var items = $(this).next();
        items.slideUp();
        $(this).addClass("collapsed");
      });
    }
 
   
  // Call the function on window load to collapse all on mobile view
  $(window).on("load", function () {
    if (isMobileView()) {
      collapseAllFilterItems();
    }
  });

  
  $(document).on("click", ".blm-category-control-button", function () {
    $("body").toggleClass("overflow-auto");
  });

  $(document).on("click", ".blm-product-search-control-button", function () {
    $("body").toggleClass("overflow-auto");
  });

});

function setFilters() {
     // Function to update the selected filters display
    function updateSelectedFiltersDisplay(selectedFilters) {
      // Update the display with selected filters
      $('.selected-filters').text('Selected Filters: ' + selectedFilters.join(', '));
    }

    // Display selected filters on page load
    updateSelectedFiltersDisplay([]);

  // Function to check if any checkbox is initially checked
  function anyCheckboxCheckedInitially(checkboxSelector) {
    return $(checkboxSelector + ':checked').length > 0;
  }

  // Hide clear button on load if no filters are initially selected
  $('.blm-clear').toggle(anyCheckboxCheckedInitially('.blm-category-filter-item__checkbox') || anyCheckboxCheckedInitially('.blm-product-search-filter-item__checkbox'));

  // Function to handle checkbox change event
  function handleCheckboxChange(checkboxSelector) {
      var selectedFilters = [];

      $(checkboxSelector + ':checked').each(function () {
        selectedFilters.push($(this).val());
      });

      // Update selected filters display
      updateSelectedFiltersDisplay(selectedFilters);
    var anyCheckboxChecked = $(checkboxSelector + ':checked').length > 0;
     // Update selected filters display

    $('.blm-clear').toggle(anyCheckboxChecked);

    if (anyCheckboxChecked) {
      setTimeout(setAspectRatio, 1000);
      setTimeout(logAllURLParameters,1000);
    } else{
       setTimeout(setAspectRatio, 1000);
      setTimeout(logAllURLParameters,1000);
      
    }
  }

  // Checkbox change event for category filters
  $(document).on('change', '.blm-category-filter-item__checkbox', function () {
    handleCheckboxChange('.blm-category-filter-item__checkbox');
  });

  // Checkbox change event for product search filters
  $(document).on('change', '.blm-product-search-filter-item__checkbox', function () {
    handleCheckboxChange('.blm-product-search-filter-item__checkbox');
  });

  // Clear All filters
  $(document).on('click', '.blm-clear-all', function () {
    $('.blm-category-filter-item__checkbox, .blm-product-search-filter-item__checkbox').prop('checked', false);
    setTimeout(setAspectRatio, 2000);
    $('.blm-clear').hide();
    removeQueryParameters();
  });
}

function removeQueryParameters() {
  var urlParams = new URLSearchParams(window.location.search);

    // Remove 'fq' parameter
    urlParams.delete('fq');

    // Update the URL without 'fq' parameter
    var newURL = window.location.origin + window.location.pathname;

    // Add back other parameters (if any)
    var searchParams = urlParams.toString();
    if (searchParams.length > 0) {
      newURL += '?' + searchParams;
    }

    // Update the URL without triggering a page reload
    window.history.replaceState({}, document.title, newURL);;
    window.location.reload();
  }

//set the aspect Ratio 
function setAspectRatio() {
    const minRatio = [];
     var fragmentCount= 4;
     let prodClass ;
    if(window.matchMedia("(max-width: 1000px)").matches){
      fragmentCount = 2;
    }
    if($(".blm-product-search-image-container").length > 0){
      prodClass = $(".blm-product-search-image-container")
    }
    else {
      prodClass =  $(".blm-category-image-container")
    }
    prodClass.each(function (index) {
            let ratio;
            if($(".blm-product-search-image-container").length > 0){
              
                 ratio = $(this).find(".blm-product-search-swatch-image")
                .find(".blm-search-details-img")
                .find(".blm-product-search-image-container__image")[0].naturalWidth /
                $(this).find(".blm-product-search-swatch-image")
                    .find(".blm-search-details-img")
                    .find(".blm-product-search-image-container__image")[0].naturalHeight;
              }
            else {
               
                 ratio = $(this).find(".blm-category-swatch-image")
                .find(".blm-category-details-img")
                .find(".blm-category-image-container__image")[0].naturalWidth /
                $(this).find(".blm-category-swatch-image")
                    .find(".blm-category-details-img")
                    .find(".blm-category-image-container__image")[0].naturalHeight;
            }
            const arrayindex = Math.floor(index / fragmentCount);
           
            // Initialize the subarray if it doesn't exist
            if (!minRatio[arrayindex]) {
                minRatio[arrayindex] = [];
              if(arrayindex >0){
                const min = Math.min(...minRatio[arrayindex-1])
               
               if(fragmentCount === 4) {
                var el = prodClass[index-4];
                el.style.aspectRatio=min
                var el = prodClass[index-3];
               el.style.aspectRatio=min
               }
                var el =prodClass[index-2];
               el.style.aspectRatio=min
                var el =prodClass[index-1];
               el.style.aspectRatio=min
               
            }
            }

            minRatio[arrayindex].unshift(ratio);
            if( index ===  prodClass.length-1){
             const min = Math.min(...minRatio[arrayindex])
          
                if(fragmentCount === 4) {
                   if((index+1)% 4 === 0){
                var el = prodClass[index-3];
                   el.style.aspectRatio=min
                    var el = prodClass[index-2];
                   el.style.aspectRatio=min
                    var el = prodClass[index-1];
                   el.style.aspectRatio=min
                    var el = prodClass[index];
                   el.style.aspectRatio=min
              }else if((index+1)% 4 === 3){
                    var el = prodClass[index-2];
                   el.style.aspectRatio=min
                    var el = prodClass[index-1];
                   el.style.aspectRatio=min
                    var el = prodClass[index];
                   el.style.aspectRatio=min
              }
                }
              if((index+1)% fragmentCount=== 2 || (index+1)% fragmentCount=== 0){
                    var el = prodClass[index-1];
                   el.style.aspectRatio=min
                    var el = prodClass[index];
                   el.style.aspectRatio=min
              }else if((index+1)% fragmentCount === 1){
                    var el = prodClass[index];
                   el.style.aspectRatio=min
              }           
      }   
      
    });
}

function logAllURLParameters() {
    const urlParams = new URLSearchParams(window.location.search);

    let hasColorFilter = false;
    let hasOnlyPriceFilter = false;

    let containerSelector;
    if ($(".blm-product-search-image-container").length > 0) {
        containerSelector = ".blm-product-search__result";
    } else {
        containerSelector = ".blm-category__result";
    }

    urlParams.forEach((value, key) => {
        if (key === 'fq') {
            if (value.includes('color_groups') || value.includes('colors') || value.includes('Color')) {
                hasColorFilter = true;
            }

            if (value.includes('price')) {
                hasOnlyPriceFilter = true;
            }
        }
    });

    if (hasColorFilter) {
        showThumbImage(containerSelector);
    } else {
        showFeaturedImage(containerSelector);
    }
   setTimeout(setPriceRangeSlider,1000)
}
//set the search parameter on click on enter key
function setSearchParameter(){
var searchInputElement = document.getElementById('blm-search-input');
/*searchInputElement.addEventListener('keydown', function (e) {
        if (e.keyCode === 13) { // Check if Enter key is pressed
          e.preventDefault();
          updateSearchUrl(searchInputElement.value.trim().replace(/\s+/g, '+'));
          window.location.reload();
        }
    }); 
}*/
if(searchInputElement){
  searchInputElement.addEventListener('keydown', function (e) {
          if (e.keyCode === 13) { // Check if Enter key is pressed
            // check search box length (don't allow empty query)
            if (searchInputElement.value.length < 2) {
              e.preventDefault();
            }
            else {
              e.preventDefault();
              updateSearchUrl(searchInputElement.value.trim().replace(/\s+/g, '+'));
              window.location.reload();
            }
          }
      }); 
  }
}

function updateSearchUrl(searchValue) {
    var currentUrl = window.location.href;
    var hasSearchPath = currentUrl.includes("/search/");
    var newUrl;
    var newUrl = window.location.origin + '/search?q=' + searchValue;
    window.history.replaceState(null, '', newUrl);
}

// Function to show thumb image
function showThumbImage(containerSelector) {
    showImages(containerSelector, true);
}

// Function to show featured image
function showFeaturedImage(containerSelector) {
    showImages(containerSelector, false);
}
function showImages(containerSelector, showThumb) {
    const productCardContainers = document.querySelectorAll(containerSelector);
    productCardContainers.forEach(productCardContainer => {
        const thumbImage = productCardContainer.querySelector('.thumbImage');
        const featuredImage = productCardContainer.querySelector('.featuredImage');

        if (thumbImage && featuredImage) {
            thumbImage.style.display = showThumb ? 'block' : 'none';
            featuredImage.style.display = showThumb ? 'none' : 'block';
        }
    });
}

function setPriceRangeSlider() {
  var minRangeSlider = document.querySelector(".blm-price-range-input--lower");
  var maxRangeSlider = document.querySelector(".blm-price-range-input--upper");

  let priceRangeContainer = document.querySelector(".blm-price-range-container");
  
  // Check if elements are found before proceeding
  if (!minRangeSlider || !maxRangeSlider) {
      if (priceRangeContainer)
        priceRangeContainer.style.display = 'none';
      return;
  }
  
  minRangeSlider.removeEventListener("change", handleSliderInput);
  maxRangeSlider.removeEventListener("change", handleSliderInput);

  function handleSliderInput() {
    console.log("handleSliderInput");
    setTimeout(logAllURLParameters, 1000);
    setTimeout(setAspectRatio, 1000);
  }

  minRangeSlider.addEventListener("change", handleSliderInput);
  maxRangeSlider.addEventListener("change", handleSliderInput);
}

function setSortChange(){
  $(document).on('change', '.blm-category-toolbar-options__select', function () {
   setTimeout(setAspectRatio, 2000);
});
  $(document).on('change', '.blm-product-search-toolbar-options__select', function () {
   setTimeout(setAspectRatio, 2000);
});
}
